export default "__VITE_ASSET__SwxJyRdC__"